import { HelplineBar, Navbar } from "../components/Chrome";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import { Mission, Values, Pillars } from "../components/Sections";
import HarmMatrix from "../components/HarmMatrix";
import Poem from "../components/Poem";
import Stories from "../components/Stories";
import Connectedness from "../components/Connectedness";
import WhanauGuide from "../components/WhanauGuide";
import Evidence from "../components/Evidence";
import PledgeWall from "../components/PledgeWall";
import { Plan, Team, Launch } from "../components/Plan";
import Support from "../components/Support";
import Media from "../components/Media";
import Footer from "../components/Footer";
import ChatWidget from "../components/ChatWidget";

export default function Home() {
  return (
    <div className="bg-[#090A0F] min-h-screen" data-testid="home-page">
      <HelplineBar />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Mission />
        <Values />
        <Pillars />
        <HarmMatrix />
        <Poem />
        <Stories />
        <Connectedness />
        <WhanauGuide />
        <Evidence />
        <PledgeWall />
        <Plan />
        <Team />
        <Launch />
        <Support />
        <Media />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
